import { OktonLoadingCard, OktonErrorCard } from '@okton/platform-ui';
import { Box, Spinner, Tooltip } from '@chakra-ui/react';
import React from 'react';

interface CargaGraficoProps {
  titulo: string;
  isLoading: boolean;
  isError: boolean;
  error?: unknown;
  onRetry: () => void;
  h: string;
  // Dados de um filtro anterior na tela enquanto os do novo chegam.
  atualizando?: boolean;
  children: React.ReactElement;
}

// O Chart não tem estado de carga. Na primeira consulta, o mesmo LoadingFlex
// que as telas do Analytics mostram, na altura do gráfico; nas seguintes o
// gráfico fica e só um indicador pequeno avisa que está atualizando - trocá-lo
// pelo LoadingFlex desmontaria o gráfico e mataria a transição.
const CargaGrafico: React.FC<CargaGraficoProps> = ({
  titulo,
  isLoading,
  isError,
  error,
  onRetry,
  h,
  atualizando,
  children,
}) => {
  if (isLoading) return <OktonLoadingCard h={h} title={titulo} />;
  if (isError)
    return (
      <OktonErrorCard
        h={h}
        description={
          error instanceof Error && error.message
            ? error.message
            : 'Tente novamente. Se o problema persistir, contate o suporte.'
        }
        onRetry={onRetry}
      />
    );
  return (
    <Box position="relative" w="100%" minW="0">
      {children}
      {atualizando && (
        <Tooltip label="Atualizando" openDelay={300}>
          <Spinner
            position="absolute"
            top="6"
            right="16"
            size="sm"
            color="blue.500"
            speed="0.8s"
            aria-label="Atualizando"
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default CargaGrafico;
